export const baseUrlAdmin = "https://arinashopping.com:5006";
export const baseUrlUser = "https://arinashopping.com:5001";

export const apiBaseUrlAdmin = baseUrlAdmin + "/api";
export const apiBaseUrlUser = baseUrlUser + "/api";

export const shareUrl = "https://arinashopping.com/products";
export const tracePayUrl = "https://bees.express:8001/api";